import { SnackbarProvider } from 'notistack';
import {
  Route,
  BrowserRouter as Router
} from "react-router-dom";
import './App.css';
import { UnderMaintenance } from './components/molecules/UnderMaintenance';
import { AnnualStatementPage } from './pages/AnnualStatementPage';
import { AplicationFormPensionerIdentityCardPage } from './pages/AplicationFormPensionerIdentityCardPage';
import { CircularPage } from './pages/CircularPage';
import { DashboardPage } from './pages/DashboardPage';
import { EmpAnnualStatementPage } from './pages/EmpAnnualStatementPage';
import { EmpPayslipPage } from './pages/EmpPayslipPage';
import { Form16Page } from './pages/Form16Page';
import { KnowApplStatusPage } from './pages/KnowApplicationStatusPage';
import { KnowPensionerIdPage } from './pages/KnowPensionerIdPage';
import { LifeCertificatePage } from './pages/LifeCertificatePage';
import { MonthlyPayStatementPage } from './pages/MonthlyPayStatementPage';
import { OptRaxRegimePage } from './pages/OptRaxRegimePage';
import { PDFUpload } from './pages/PDFUpload';
import { PensionerProfilePage } from './pages/PensionerProfilePage';
import { PPODetailPage } from './pages/PPODetailsPage';
import { SignInPage } from './pages/SignInPage';
import { TerminalBenefitStatementPage } from './pages/TerminalBenefitStatementPage';
import { TrackPensionerIdentityCardPage } from './pages/TrackPensionerIdentityCardPage';
import { UpdateMobileNumberPage } from './pages/UpdateMobileNumberPage';
import { PrivateRoute } from './PrivateRoute';
import { createInitalStore, StoreProvider } from './store';
function App() {
  return (
    <StoreProvider store={createInitalStore()}>
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} preventDuplicate={true}>
        <Router>
          <Route exact path="/login">
            <SignInPage />
          </Route>
          <Route exact path="/update-mobile">
            <UpdateMobileNumberPage />
          </Route>
          <Route exact path="/know-pensioner-id">
            <KnowPensionerIdPage />
          </Route>
          <Route exact path="/know-appl-status">
            <KnowApplStatusPage />
          </Route>
          <PrivateRoute exact path="/aplication-form-pensioners-identity-card">
            <AplicationFormPensionerIdentityCardPage />
          </PrivateRoute>
          <PrivateRoute exact path="/track-pensioners-identity-card">
            <TrackPensionerIdentityCardPage />
          </PrivateRoute>
          <PrivateRoute exact path="/upload-attested-appl-form">
            <PDFUpload />
          </PrivateRoute>
          <PrivateRoute exact path="/monthly-pay-statement">
            {/* <UnderMaintenance pageName="Monthly Statement" /> */}
            <MonthlyPayStatementPage />
          </PrivateRoute>
          <PrivateRoute exact path="/opt-tax-regime">
            <OptRaxRegimePage />
          </PrivateRoute>
          <PrivateRoute exact path="/annual-statement">
            {/* <UnderMaintenance pageName="Annual Statement" /> */}
            <AnnualStatementPage />
          </PrivateRoute>
          <PrivateRoute exact path="/it-declaration">
            <UnderMaintenance pageName="IT Declaration" />
          </PrivateRoute>
          <PrivateRoute exact path="/form16">
            <Form16Page />
          </PrivateRoute>
          <PrivateRoute exact path="/ppo">
            <PPODetailPage />
          </PrivateRoute>
          <PrivateRoute exact path="/life-certificate">
            <LifeCertificatePage />
          </PrivateRoute>
          <PrivateRoute exact path="/circulars">
            <CircularPage />
          </PrivateRoute>
          <PrivateRoute exact path="/">
            <DashboardPage />
          </PrivateRoute>
          <Route exact path="/profile-details">
            <PensionerProfilePage />
          </Route>
          <PrivateRoute exact path="/payslip">
            <EmpPayslipPage />
          </PrivateRoute>
          <PrivateRoute exact path="/terminal-benefit-statement">
            <TerminalBenefitStatementPage />
          </PrivateRoute>
          <PrivateRoute exact path="/emp-annual-statement">
            <EmpAnnualStatementPage />
          </PrivateRoute>
        </Router>
      </SnackbarProvider>
    </StoreProvider>
  );
}

export default App;
